import React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

interface ConfirmDeleteDialogProps {
  open: boolean;
  dialog: {
    title: string;
    content: string;
  };
  actions: {
    close: () => void;
    delete: () => void;
  },
  icon?: React.ReactNode;
}

const ConfirmDeleteDialog = (props: ConfirmDeleteDialogProps) => {
  const { t } = useTranslation();
  const { open, dialog, actions, icon } = props;

  return (
    <Dialog
      open={open}
      onClose={actions.close}
      fullWidth
      maxWidth="xs"
      sx={{
        '& .MuiDialog-paper': {
          padding: '24px',
        },
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        {icon}
        <DialogTitle
          variant="h3"
          sx={{
            fontSize: 18,
            lineHeight: '100%',
            letterSpacing: 0.1,
            textAlign: 'center',
            p: 0,
          }}
        >
          {dialog.title}
        </DialogTitle>
      </Box>
      <DialogContent>
        <Typography
          variant="body1"
          sx={{
            fontFamily: 'Open Sans',
            fontStyle: 'Regular',
            lineHeight: '150%',
            letterSpacing: 0.15,
            textAlign: 'center',
          }}
        >
          {dialog.content}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="text" color="primary" onClick={actions.close}>
          {t('actions.cancel')}
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={actions.delete}
        >
          {t('actions.delete')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDeleteDialog;
